import { render, staticRenderFns } from "./EditPracticeSendingDialog.vue?vue&type=template&id=65de837e&scoped=true"
import script from "./EditPracticeSendingDialog.vue?vue&type=script&lang=ts"
export * from "./EditPracticeSendingDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditPracticeSendingDialog.vue?vue&type=style&index=0&id=65de837e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65de837e",
  null
  
)

export default component.exports